"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsupportedClientError = void 0;
const is_error_1 = require("./is-error");
const error_codes_1 = require("../lib/error-codes");
const args_1 = require("../lib/args");
/**
 * When the request comes from an app or program that we do not recognize or support
 */
class UnsupportedClientError extends is_error_1.IsError {
    constructor(messageOrError, errorOrArgs, args) {
        const { message, originalError, errorArgs } = (0, args_1.readErrorArgs)(messageOrError, errorOrArgs, args);
        super(error_codes_1.StatusErrorCode.UNSUPPORTED_CLIENT, UnsupportedClientError.name, message, errorArgs?.reasonCode || error_codes_1.ErrorGenericReasonCode.UNSUPPORTED_CLIENT, errorArgs?.userMessage || error_codes_1.ErrorMessage.UNSUPPORTED_CLIENT, originalError, errorArgs);
    }
}
exports.UnsupportedClientError = UnsupportedClientError;
